// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal[data-v-ba386c66]{background:#fff;border-color:#9c9c9c}.active[data-v-ba386c66]{background:#f1f1ff}.v-menu__content[data-v-ba386c66]{border-radius:20px}", ""]);
// Exports
module.exports = exports;
